module.exports = __webpack_public_path__ + "img/pos6_banner1.a5fc544d.png";